module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "year"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'input-group': _vm.group
    }
  }, [(_vm.group) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "year",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione um ano letivo")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      domProps: {
        "value": year.id
      }
    }, [_vm._v(_vm._s(year.value))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18a32fb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/components/calendar/year/main.vue
// module id = 1039
// module chunks = 1